import { CardEventType } from '../Stats/utils';

export const cardColorClass: Record<CardEventType, string> = {
  GREEN_CARD: 'bg-green',
  RED_CARD: 'bg-red',
  YELLOW_CARD: 'bg-amber-400',
};
